<template>
  <div
    :id="id"
    class="dialog-container"
    :class="{ visible: isVisible }"
  >
    <div
      class="dialog"
      :class="[size, { scrollable }]"
    >
      <div
        v-if="dismissible"
        class="dialog-title"
      >
        <Icon
          class="dialog-close-icon"
          name="close"
          @click="hide"
        />
        <h3
          v-if="title"
          class="text-left"
        >
          {{ title }}
        </h3>
      </div>
      <div
        v-else-if="title"
        class="dialog-title"
      >
        <h3 class="text-center">
          {{ title }}
        </h3>
      </div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Icon from './Icon.vue'

@Options({
  components: {
    Icon,
  },
  props: {
    id: { type: String, default: '' },
    title: { type: String, default: '' },
    size: { type: String, default: '' },
    scrollable: { type: Boolean, default: false },
    dismissible: { type: Boolean, default: false },
  },
})

export default class Dialog extends Vue {
  isVisible = false
  id!: string
  title!: string
  size!: string
  scrollable!: boolean
  dismissible!: boolean

  show() {
    this.isVisible = true;
    document.body.classList.add('dialog-open');
    document.querySelectorAll('body *').forEach(el => {
      if (!el.closest('.dialog')) {
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  hide() {
    this.isVisible = false;
    document.body.classList.remove('dialog-open');
    document.querySelectorAll('body *').forEach(el => {
      if (!el.closest('.dialog')) {
        el.setAttribute('tabindex', '0');
      }
    });
    this.$emit('dialog-closed');
  }
}
</script>
